import { pageMetadataSchema } from '../../../schema/pageMetadata.val';
import { c, nextAppRouter, s } from '../../../val.config';

export const schema = s.object({
  header: s.string(),
  subheader: s.string(),
  pageImage: s.image(),
  pageMetdata: pageMetadataSchema,
});

export default c.define(
  '/app/(main)/menneskene/page.val.ts',
  s.router(nextAppRouter, schema),
  {
    '/menneskene': {
      subheader: 'Møt folkene i Blank',
      header: 'Våre folk',
      pageImage: {
        path: '/public/val/2022-05blanks7-arsjubileum-179_199e0.jpg',
        width: 3000,
        height: 1500,
        mimeType: 'image/jpeg',
        hotspot: { x: 0.4583333333333333, y: 0.49 },
        alt: 'Jobbtur til Italia',
      },
      pageMetdata: {
        title: 'Folka i Blank',
        description:
          'Designerne, teknologene og de andre som jobber i Blank. Vi er ingenting - bokstavelig talt - uten menneskene!',
        image: null,
      },
    },
  }
);
